/**
 * ============================================================================
 * 🖼️ Expanded Photo Lightbox Modal Controller
 * ============================================================================
 */

import { renderPhotoDots } from '../utils/photoDots.js';

export class LightboxController {
  constructor() {
    this.overlay = document.getElementById('photo-expanded-modal');
    this.imgEl = document.getElementById('modal-main-img');
    this.titleEl = document.getElementById('modal-aircraft-title');
    this.creditEl = document.getElementById('modal-credit-text');
    this.dotsContainer = document.getElementById('modal-dots-container');
    this.btnPrev = document.getElementById('modal-btn-prev');
    this.btnNext = document.getElementById('modal-btn-next');
    this.btnClose = document.getElementById('modal-btn-close');

    this.photos = [];
    this.currentIndex = 0;
    this.planeData = null;

    this.init();
  }

  init() {
    if (this.btnClose) {
      this.btnClose.addEventListener('click', (e) => {
        e.stopPropagation();
        this.hide();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.hide();
      });
    }

    if (this.btnPrev) {
      this.btnPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        this.prev();
      });
    }

    if (this.btnNext) {
      this.btnNext.addEventListener('click', (e) => {
        e.stopPropagation();
        this.next();
      });
    }

    // Keyboard navigation (Esc / Arrow Keys)
    window.addEventListener('keydown', (e) => {
      if (!this.overlay || this.overlay.classList.contains('hidden')) return;
      if (e.key === 'Escape') this.hide();
      else if (e.key === 'ArrowLeft') this.prev();
      else if (e.key === 'ArrowRight') this.next();
    });
  }

  open(photos, startIndex = 0, planeData = null) {
    if (!photos || photos.length === 0) return;
    this.photos = photos;
    this.currentIndex = Math.max(0, Math.min(startIndex, photos.length - 1));
    this.planeData = planeData;

    this.render();
    if (this.overlay) this.overlay.classList.remove('hidden');
  }

  hide() {
    if (this.overlay) this.overlay.classList.add('hidden');
  }

  prev() {
    if (this.photos.length <= 1) return;
    this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length;
    this.render();
  }

  next() {
    if (this.photos.length <= 1) return;
    this.currentIndex = (this.currentIndex + 1) % this.photos.length;
    this.render();
  }

  render() {
    const cur = this.photos[this.currentIndex];
    if (!cur) return;

    if (this.imgEl) this.imgEl.src = cur.url;

    if (this.titleEl) {
      const plane = this.planeData;
      const model = plane ? (plane.aircraft_model || plane.aircraft_code || 'Aircraft') : 'Aircraft';
      const reg = plane ? (plane.registration || '') : '';
      const cs = plane ? (plane.callsign || '') : '';
      this.titleEl.textContent = `${model} ${reg ? '\u00B7 ' + reg : ''} ${cs ? '(' + cs + ')' : ''}`;
    }

    if (this.creditEl) {
      this.creditEl.textContent = `Photographer: ${cur.photographer || 'Verified JetPhotos CDN'}`;
    }

    // Nav Arrows Visibility
    if (this.btnPrev && this.btnNext) {
      const hasMultiple = this.photos.length > 1;
      this.btnPrev.style.display = hasMultiple ? 'flex' : 'none';
      this.btnNext.style.display = hasMultiple ? 'flex' : 'none';
    }

    renderPhotoDots(this.dotsContainer, this.photos.length, this.currentIndex, (idx) => {
      this.currentIndex = idx;
      this.render();
    });
  }
}
